import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { Dashboard } from '@uppy/react';
import PropTypes from 'prop-types';
import React from 'react';
import Dialog from '@panneau/modal-dialog';
import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.min.css';
import '@uppy/drag-drop/dist/style.min.css';
import '@uppy/status-bar/dist/style.min.css';

var styles = {};

var _excluded = ["id", "title", "uppy", "plugins", "onClose"];
var propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  title: PropTypes.string,
  uppy: PropTypes.shape({
    reset: PropTypes.func
  }),
  plugins: PropTypes.arrayOf(PropTypes.string),
  onClose: PropTypes.func
};
var defaultProps = {
  title: null,
  uppy: null,
  plugins: [],
  onClose: null
};
var UploadModal = function UploadModal(_ref) {
  var id = _ref.id,
    title = _ref.title,
    uppy = _ref.uppy,
    plugins = _ref.plugins,
    onClose = _ref.onClose,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Dialog, {
    id: id,
    size: "lg",
    onClose: onClose,
    title: title
  }, uppy !== null ? /*#__PURE__*/React.createElement(Dashboard, Object.assign({
    inline: true,
    width: "100%",
    height: "350px",
    showAddFilesPanel: true,
    proudlyDisplayPoweredByUppy: false
  }, props, {
    className: styles.container,
    uppy: uppy,
    onRequestClose: onClose,
    plugins: plugins
  })) : null);
};
UploadModal.propTypes = propTypes;
UploadModal.defaultProps = defaultProps;

export { UploadModal as default };
